import { render, staticRenderFns } from "./BalanceHistory.vue?vue&type=template&id=16a23c8f&"
import script from "./BalanceHistory.vue?vue&type=script&lang=ts&"
export * from "./BalanceHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports